import { makeAutoObservable, runInAction } from 'mobx'

class Users {
  users = []
  currentUser = {}
  isAdmin = false
  isProStamper = false
  isRoleDefine = false
  isHeadOfProduction = false

  constructor() {
    makeAutoObservable(this)
  }

  setCurrentUser(user) {
    this.currentUser = user
  }
  setIsAdmin(isAdmin){
    runInAction(() => {
      this.isAdmin = isAdmin || false
      this.isRoleDefine = true
    })
  }
  setIsProStamper(isProStamper){
    runInAction(() => {
      this.isProStamper = isProStamper || false
      this.isRoleDefine = true
    })
  }
  setIsHeadOfProduction(isHeadOfProduction){
    runInAction(() => {
      this.isHeadOfProduction = isHeadOfProduction || false
      this.isRoleDefine = true
    })
  }
  setUsers(users) {
    const slamAdminUsername = 'АДМИН SLAM'
    const isProduction = process.env.REACT_APP_IS_PROD === 'true'
    this.users = isProduction ? users.filter(u => u.username !== slamAdminUsername) : users
  }

  isGodMod() {
    return this.currentUser?.role?.find(x => x.godmod)
  }
}

const users = new Users()

export default users
